export const darkTheme = {
    bg: "#1C1C27", // Dark Slate for the main background
    bgLight: "#2A2B3D", // Dark Blue for light backgrounds
    primary: "#4682B4", // Steel Blue for primary elements
    text_primary: "#F2F3F4", // Off White for primary text
    text_secondary: "#B1B2B3", // Light Gray for secondary text
    card: "#171721", // Darker Gray for cards
    card_light: "#19212C", // Dark Blue for light cards
    button: "#5B9BD5", // Moderate Blue for buttons
    white: "#FFFFFF",
    black: "#000000",
  };

  export const lightTheme = {
    bg: "#FCFDFE", // Very light off-white for main background
    bgLight: "#F2F4F5", // Slightly darker off-white for contrast
    primary: "#03970c", // Calming green for primary elements
    text_primary: "#060606", // Darker slate blue for text
    text_tertiary: "#F2F3F4",
    text_secondary: "#060606", // Softer slate gray for secondary text
    card: "#FFFFFF", // Pure white for cards
    button: "#5DBB9D", // Bright green for button emphasis
    white: "#FFFFFF",
    black: "#000000",
};
